import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(VCombobox, {
    staticClass: "price-search",
    class: { "price-search--mobile": _setup.isMobile },
    attrs: {
      items: _setup.visibleItems,
      placeholder: _setup.placeholder,
      "menu-props": _setup.menuProps,
      "prepend-inner-icon": "ui-icon-search text-info--text",
      "append-icon": "",
      "clear-icon": "ui-icon-close-not-a-circle",
      "background-color": "bg-gray-40",
      solo: "",
      flat: "",
      clearable: "",
      "hide-details": "",
      "no-filter": "",
      "hide-no-data": "",
      height: "56",
      "data-qa": "lpu_services_search",
    },
    on: {
      "update:search-input": _setup.onSearchInput,
      "click:clear": _setup.onClear,
      focus: _setup.onFocus,
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item, on }) {
          return [
            _c(
              VListItem,
              _vm._g({ attrs: { "data-qa": "lpu_services_search_item" } }, on),
              [
                _c(
                  VListItemContent,
                  {
                    on: {
                      click: function ($event) {
                        _setup.onSelectClass(String(item))
                      },
                    },
                  },
                  [_c(VListItemTitle, [_vm._v(_vm._s(item))])],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
    model: {
      value: _setup.model,
      callback: function ($$v) {
        _setup.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }